<ng-template #directDepositChangeReviewModal let-modal>
  <div class="modal-header justify-content-between">
    <div>
      <h4 class="modal-title d-inline-block fw-bold">Direct Deposit Change Request</h4>
      <br />
      <small class="ms-2"
        ><span *ngIf="!isEmployeePortal">{{ changeRequest.RequesterName }} - </span
        ><span class="fw-bold">Date Requested: </span
        >{{ changeRequest.DateRequested | date: 'MM/dd/YY' }}</small
      >
    </div>
    <div>
      <span *ngIf="changeRequest.Approved" class="badge bg-connectpay">Approved</span>
      <span *ngIf="!changeRequest.Approved && !changeRequest.Pending" class="badge bg-danger"
        >Declined</span
      >
      <span *ngIf="changeRequest.Pending" class="badge bg-warning">Pending</span>
      <button type="button" class="close ms-3" aria-label="Close" (click)="modal.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <ng-container
      *ngIf="changeRequestData.New.Disabled != null && changeRequestData.New.Disabled.length > 0">
      <div class="row">
        <div class="col-12">
          <span class="fw-bold">Deactivate Account</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card p-2">
            <div class="d-flex justify-content-between">
              <div class="d-flex flex-column">
                <div class="fw-bold">Bank</div>
                <span *ngFor="let disabledAccount of changeRequestData.New.Disabled">
                  {{ disabledAccount.BankName }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Routing</div>
                <span *ngFor="let disabledAccount of changeRequestData.New.Disabled">
                  {{ disabledAccount.RoutingNumber }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Account</div>
                <span *ngFor="let disabledAccount of changeRequestData.New.Disabled">
                  {{ disabledAccount.AccountNumber }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Account Type</div>
                <ng-container *ngFor="let disabledAccount of changeRequestData.New.Disabled">
                  <span *ngIf="disabledAccount.AccountType == 0">Checking</span>
                  <span *ngIf="disabledAccount.AccountType == 1">Savings</span>
                  <span *ngIf="disabledAccount.AccountType == 2">IRA</span>
                </ng-container>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Amount Type</div>
                <span *ngFor="let disabledAccount of changeRequestData.New.Disabled">
                  <span *ngIf="disabledAccount.CalculationMethod == 0">Dollar</span>
                  <span *ngIf="disabledAccount.CalculationMethod == 1">Percent of Net</span>
                  <span *ngIf="disabledAccount.CalculationMethod == 2">Net Remaining</span>
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Amount</div>
                <span *ngFor="let disabledAccount of changeRequestData.New.Disabled">
                  <span *ngIf="disabledAccount.CalculationMethod == 1"
                    >{{ disabledAccount.Amount }}%</span
                  >
                  <span *ngIf="disabledAccount.CalculationMethod == 0"
                    >${{ disabledAccount.Amount }}</span
                  >
                  <span *ngIf="disabledAccount.CalculationMethod == 2"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="changeRequestData.New.New != null && changeRequestData.New.New.length > 0">
      <div class="row">
        <div class="col-12">
          <span class="fw-bold">Add Account</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card p-2">
            <div class="d-flex justify-content-between">
              <div class="d-flex flex-column">
                <div class="fw-bold">Bank</div>
                <span *ngFor="let newAccount of changeRequestData.New.New">
                  {{ newAccount.BankName }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Routing</div>
                <span *ngFor="let newAccount of changeRequestData.New.New">
                  {{ newAccount.RoutingNumber }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Account</div>
                <span *ngFor="let newAccount of changeRequestData.New.New">
                  {{ newAccount.AccountNumber }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Account Type</div>
                <ng-container *ngFor="let newAccount of changeRequestData.New.New">
                  <span *ngIf="newAccount.AccountType == 0">Checking</span>
                  <span *ngIf="newAccount.AccountType == 1">Savings</span>
                  <span *ngIf="newAccount.AccountType == 2">IRA</span>
                </ng-container>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Amount Type</div>
                <ng-container *ngFor="let newAccount of changeRequestData.New.New">
                  <span *ngIf="newAccount.CalculationMethod == 0">Dollar</span>
                  <span *ngIf="newAccount.CalculationMethod == 1">Percent of Net</span>
                  <span *ngIf="newAccount.CalculationMethod == 2">Net Remaining</span>
                </ng-container>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Amount</div>
                <ng-container *ngFor="let newAccount of changeRequestData.New.New">
                  <span *ngIf="newAccount.CalculationMethod == 1">{{ newAccount.Amount }}%</span>
                  <span *ngIf="newAccount.CalculationMethod == 0">${{ newAccount.Amount }}</span>
                  <span *ngIf="newAccount.CalculationMethod == 2"></span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        changeRequestData.New.AllocationChange != null &&
        changeRequestData.New.AllocationChange.length > 0
      ">
      <div class="row">
        <div class="col-12">
          <span class="fw-bold">Change Allocation</span>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="card p-2">
            <div class="d-flex justify-content-between">
              <div class="d-flex flex-column">
                <div class="fw-bold">Bank</div>
                <span *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  {{ newAccount.BankName }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Routing</div>
                <span *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  {{ newAccount.RoutingNumber }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Account</div>
                <span *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  {{ newAccount.AccountNumber }}
                </span>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Account Type</div>
                <ng-container *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  <span *ngIf="newAccount.AccountType == 0">Checking</span>
                  <span *ngIf="newAccount.AccountType == 1">Savings</span>
                  <span *ngIf="newAccount.AccountType == 2">IRA</span>
                </ng-container>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">Old</div>
                <ng-container *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  <span *ngIf="newAccount.OldCalculationMethod == 0">Dollar</span>
                  <span *ngIf="newAccount.OldCalculationMethod == 1">Percent of Net</span>
                  <span *ngIf="newAccount.OldCalculationMethod == 2">Net Remaining</span>
                </ng-container>
              </div>
              <div class="d-flex flex-column justify-content-end">
                <ng-container *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  <span *ngIf="newAccount.OldCalculationMethod == 1"
                    >{{ newAccount.OldAmount }}%</span
                  >
                  <span *ngIf="newAccount.OldCalculationMethod == 0"
                    >${{ newAccount.OldAmount }}</span
                  >
                  <span *ngIf="newAccount.OldCalculationMethod == 2">&nbsp;</span>
                </ng-container>
              </div>
              <div class="d-flex flex-column">
                <div class="fw-bold">New</div>
                <ng-container *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  <span *ngIf="newAccount.CalculationMethod == 0">Dollar</span>
                  <span *ngIf="newAccount.CalculationMethod == 1">Percent of Net</span>
                  <span *ngIf="newAccount.CalculationMethod == 2">Net Remaining</span>
                </ng-container>
              </div>
              <div class="d-flex flex-column justify-content-end">
                <ng-container *ngFor="let newAccount of changeRequestData.New.AllocationChange">
                  <span *ngIf="newAccount.CalculationMethod == 1">{{ newAccount.Amount }}%</span>
                  <span *ngIf="newAccount.CalculationMethod == 0">${{ newAccount.Amount }}</span>
                  <span *ngIf="newAccount.CalculationMethod == 2">&nbsp;</span>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="row mt-3">
      <div class="col-12">
        <label>Comment:</label>
        <textarea
          class="form-control"
          [disabled]="readonly || !allowDecision"
          [(ngModel)]="changeRequestData.Comment"></textarea>
      </div>
    </div>
  </div>
  <div class="modal-footer text-end" *ngIf="!allowDecision">
    <button class="btn btn-primary" *ngIf="readonly" (click)="closeModal()">Close</button>
    <button class="btn btn-tertiary" *ngIf="!readonly" (click)="cancelRequest()">
      Cancel Change
    </button>
    <button class="btn btn-primary" *ngIf="!readonly" (click)="closeModal()">Close</button>
  </div>
  <div class="modal-footer text-end" *ngIf="allowDecision">
    <button class="btn btn-primary" *ngIf="readonly" (click)="closeModal()">Close</button>
    <button (click)="declineRequest()" *ngIf="!readonly" class="btn btn-tertiary">Decline</button>
    <button (click)="approveRequest()" *ngIf="!readonly" class="btn btn-primary">Approve</button>
  </div>
</ng-template>
